import { getStorefrontUrl } from './getStorefrontUrl';

export const fetchToken = async (companyUuid?: string) => {
  const url = getStorefrontUrl(`/api/v1/clients/${companyUuid}/credentials`).toString();

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch token: ${response.status} ${response.statusText}`);
  }

  const token = await response.json();

  return (token?.[0] as string) || '';
};
